import ProfessionalServices from "@/services/ProfessionalServices";
import NotificationMessageServices from "@/services/NotificationMessageServices";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
const notificationMessageService = new NotificationMessageServices();

export const namespaced = true;

export const state = {
  notifications: [],
  markAsRead: false
};

export const getters = {};

export const mutations = {
  setNotifications: (state, payload) => {
    state.notifications = payload;
  },
  updateMarkAsRead: (state, payload) => {
    state.markAsRead = payload;
  }
};

export const actions = {
  readNotifications(
    { commit },
    payload = NotificationRequest.readNotifications
  ) {
    let successAction = responseData => {
      commit("setNotifications", responseData.data);
    };
    return notificationMessageService.readNotifications(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  updateStatus({ commit }, payload = NotificationRequest.updateStatus) {
    let successAction = () => {
      // commit("updateMarkAsRead", true);
    };
    return notificationMessageService.updateStatus(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  }
};
